import React, { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { SearchInput } from 'components/common/SearchInput/SearchInput';
import { Table } from 'components/common/Table/Table';
import { QueryKeys } from 'constants/query-keys';
import { UserService } from 'services/user';
import { getAddressesString, getReadableDate } from 'utils/common';

type ProviderInfo = {
  id: string;
  firstName: string;
  lastName: string;
  dob: string;
  doctorName: string;
  practice: {
    id: string;
    name: string;
  };
  email: string;
  createdAt: string;
};

export function ActiveProviders() {
  const [search, setSearch] = useState<string>('');
  const [page, setPage] = useState<number>(1);
  const navigate = useNavigate();

  const getProvidersQuery = useQuery(
    QueryKeys.Providers.listing({ page, search }),
    () => UserService.getProviders({ page, search })
  );

  useEffect(() => {
    setPage(1);
  }, [search]);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowClick = (item: ProviderInfo) => {
    navigate(`../${item.id}/overview`);
  };

  return (
    <div>
      <div className="grid">
        <span className="mb-3 flex  items-center justify-end text-base ">
          <SearchInput
            onSearch={(value) => {
              setSearch(value);
            }}
          />
        </span>
        <Table
          loading={getProvidersQuery?.status !== 'success'}
          rowsData={getProvidersQuery.data?.data?.items || []}
          columns={[
            {
              title: 'Id',
              render: (rowData) => rowData.id,
            },
            {
              title: 'Name',
              render: (rowData) => `${rowData.firstName} ${rowData.lastName}`,
            },
            {
              title: 'Email',
              render: (rowData) => rowData.email,
            },
            {
              title: 'Address',
              render: (rowData) => getAddressesString(rowData.practiceAddress),
            },
            {
              title: 'Practice',
              render: (rowData) => rowData.practice.name || 'NA',
            },
            {
              title: 'Joining Date',
              render: (rowData) => getReadableDate(rowData.createdAt),
              classNames: 'text-end',
              skeletonClassNames: 'flex justify-end',
            },
          ]}
          onRowClick={handleRowClick}
          noDataMessage="You currently have no active providers"
          pagination
          onPageChange={onPageChange}
          page={page}
          totalRecords={getProvidersQuery?.data?.data?.total || 0}
          recordsPerPage={10}
          isSticky
        />
      </div>
    </div>
  );
}
